<template>
  <div class="d-flex">
    <v-btn
      v-for="sc in scores"
      :key="sc"
      :disabled="disabled"
      icon
      color="primary"
      dark
      plain
      x-large
      @click="updateScore(sc)"
    >
      <v-icon :size="size" v-if="sc <= score">mdi-star</v-icon>
      <v-icon :size="size" v-else>mdi-star-outline</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    min: {
      type: Number,
      default: () => 0,
    },
    max: Number,
    disabled: Boolean,
    size: {
      type: String,
      default: () => '32',
    },
  },
  data() {
    return {
      score: 0,
    };
  },
  computed: {
    scores() {
      return Array.from({
        length: this.max - this.min,
      }, (_, i) => i + 1);
    },
  },
  methods: {
    getScore() {
      return this.score;
    },
    updateScore(sc) {
      this.score = sc !== this.score ? sc : 0;
      this.$emit('input', this.score);
    },
  },
};
</script>
